import { SERVICES } from '../constants/global';
import { fetch } from './fetch';

const login = async () => {
    const endpoint = '/oauth2/userinfo';
    const url = `${SERVICES}${endpoint}`;
    const res = await fetch(url, {
        credentials: 'include',
    });
    if (!res.ok) {
        let data;

        try {
            data = await res.json();
        } catch (error) {
            throw new Error('UNKNOWN');
        }
        switch (res.status) {
            case 200:
                return {
                    isLogged: true,
                };
            case 401:
                if (data !== undefined && data.authorizeUrl !== undefined) {
                    return {
                        isLogged: false,
                        redirectUri: data.authorizeUrl,
                    };
                } else {
                    throw new Error('MISSING_REDIRECT_URL');
                }
            default:
                throw new Error(data.errorCode);
        }
    }
    return {
        isLogged: true,
    };
};

export default login;
